import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { SchoolCalendar } from './school-calendar.model';
import { DateUtils } from 'ng-jhipster';
import { HttpResponse, HttpClient } from '@angular/common/http';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';
@Injectable()
export class SchoolCalendarService extends AbstractEntityService {

    protected resourceUrl = 'api/school-calendars';
    private resourceSearchUrl = 'api/_search/school-calendars';
    protected resourceCountUrl = 'api/_search/count/school-calendars';

    constructor(protected http: HttpClient, private dateUtils: DateUtils) { super(http); }

    create(schoolCalendar: SchoolCalendar, updatePackagesValididity: boolean): Observable<SchoolCalendar> {
        let copy: SchoolCalendar = Object.assign({}, schoolCalendar);

        copy.begining = this.dateUtils
            .convertLocalDateToServer(schoolCalendar.begining);
        copy.ending = this.dateUtils
            .convertLocalDateToServer(schoolCalendar.ending);
        if (updatePackagesValididity) {
            return this.http.post<SchoolCalendar>(this.resourceUrl + '?params=updatePackagesValididity', copy)
                            .map((res: SchoolCalendar) => {
                                return res;
                            });
        }
        return this.http.post<SchoolCalendar>(this.resourceUrl, copy).map((res: SchoolCalendar) => {
            return res;
        });
    }

    update(schoolCalendar: SchoolCalendar, updatePackagesValididity: boolean): Observable<SchoolCalendar> {
        let copy: SchoolCalendar = Object.assign({}, schoolCalendar);
        copy.begining = this.dateUtils
            .convertLocalDateToServer(schoolCalendar.begining);
        copy.ending = this.dateUtils
            .convertLocalDateToServer(schoolCalendar.ending);
        if (updatePackagesValididity) {
            return this.http.put<SchoolCalendar>(this.resourceUrl + '?params=updatePackagesValididity', copy)
                            .map((res: SchoolCalendar) => {
                                return res;
                            });
        }
        return this.http.put<SchoolCalendar>(this.resourceUrl, copy).map((res: Response) => {
            return res;
        });
    }

    find(id: number): Observable<SchoolCalendar> {
        return this.http.get<SchoolCalendar>(`${this.resourceUrl}/${id}`).map((res: SchoolCalendar) => {
            let jsonResponse = res;
            jsonResponse.begining = this.dateUtils
                .convertLocalDateFromServer(jsonResponse.begining);
            jsonResponse.ending = this.dateUtils
                .convertLocalDateFromServer(jsonResponse.ending);

            return jsonResponse;
        });
    }

    query(req?: any): Observable<HttpResponse<SchoolCalendar[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<SchoolCalendar[]>>(this.resourceUrl, options)
            .map((res: HttpResponse<SchoolCalendar[]>) => this.convertResponse(res))
            ;
    }

    search(req?: any): Observable<HttpResponse<SchoolCalendar[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<SchoolCalendar[]>>(this.resourceSearchUrl, options)
            .map((res: HttpResponse<SchoolCalendar[]>) => this.convertResponse(res))
            ;
    }

    count(req?: any): Observable<number> {
        let options = this.createRequestOption(req);
        return this.http.get<string>(this.resourceCountUrl, options)
            .map((res: string) => {
                return parseInt(res, 10);
            });
    }

    current(): Observable<HttpResponse<SchoolCalendar[]>> {
        let today: Date = new Date();
        let month = today.getMonth() + 1;
        let date = today.getDate();
        let beginingOperator = 'begining:<=' + today.getFullYear()
        + '-' + (month < 10 ? '0' + month : month )
        + '-' + (date < 10 ? '0' + date : date );

        let endingOperator = 'ending:>=' + today.getFullYear()
        + '-' + (month < 10 ? '0' + month : month )
        + '-' + (date < 10 ? '0' + date : date );

        let options = this.createRequestOption({
            query: beginingOperator + ' AND ' + endingOperator
        });
        return this.http.get<HttpResponse<SchoolCalendar[]>>(this.resourceSearchUrl, options)
            .map((res: any) => this.convertResponse(res))
            ;
    }

    private convertResponse(res: HttpResponse<SchoolCalendar[]>): any {
        let jsonResponse = res.body;
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].begining = this.dateUtils
                .convertLocalDateFromServer(jsonResponse[i].begining);
            jsonResponse[i].ending = this.dateUtils
                .convertLocalDateFromServer(jsonResponse[i].ending);
        }
        return res.clone({body: jsonResponse});
    }

    /**
     * Returns all calendars from the current date onwards.
     */
    getAllFromCurrentDate(): Observable<HttpResponse<SchoolCalendar[]>> {
        let today: Date = new Date();
        let dateString = today.getFullYear()
        + '-' + ('0' + (today.getMonth() + 1)).slice(-2)
        + '-' + ('0' + today.getDate()).slice(-2);

        let options = this.createRequestOption({
            query: `ending:>=${dateString}`
        });

        return this.http.get<HttpResponse<SchoolCalendar[]>>(this.resourceSearchUrl, options)
            .map((res: HttpResponse<SchoolCalendar[]>) => this.convertResponse(res));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/school-calendar/school-calendar.service.ts